import { Box, Typography, IconButton, SxProps, Tooltip } from '@mui/material'
import { useStyles } from './styles'
import { useContext, useEffect, useLayoutEffect, useMemo, useState } from 'react'
import { GlobalContext } from '../../../../../../contexts/Global'
import { useTranslation } from 'react-i18next'
import { FiltersDrawer } from '../../../../../../components/filtersDrawer'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { icons } from '../../../../../../utils/icons'
import { Item, ObjectGeneric } from '../../../../../../utils/types/generals'
import List from './modules/list'
import { useGetData } from './hooks/useGetData'
import { menuItems, reportFolioServices, resendReportForm, resendReportFormEmails, useOptionMenuReassign } from './constants/states'
import { Query } from '../../typing'
import BaseModal from '../../../../../../components/modal/baseModal'
import { LoadingButton } from '@mui/lab'
import { BaseMenu, BreadCrumb, SnackSimple } from '../../../../../../components'
import { ModelDownloadButtons } from '../../../../../../components/donwloadFiles/model'
import { useDownload } from '../../../../../../hooks/download/useDownload'
import { returnQuery, returnQueryWithPagination } from '../../../../../../utils/methods/returnQuery'
import { Status, Types } from '../../../../../../utils/enums'
import { HeaderQuestionnaire } from '../../../../../../components/headerQuestionnaire'
import { NavigatioStateType } from '../../../../../../utils/enums/navigatetionState'
import { useLocation, useNavigate } from 'react-router-dom'
import { QuestionnaireProps } from '../../../../../../components/headerQuestionnaire/types'
import { useTimeOut } from '../../../../../../hooks/timeOut'
import { ReassingModal, CancelModal, ConfirmModal } from './components'
import { MainButtons } from '../../../../Components'
import { LinearProgressDownload } from '../../../../../logbook/pages/main/components/shared/actionsTabs/linearProgressDownload'

const toggleSelection = '1'
export const Main = () => {
  const { executeFunction } = useTimeOut()
  const location = useLocation()
  const navigate = useNavigate()
  const reassignMenu = useOptionMenuReassign()
  const { colors } = useContext(GlobalContext)
  const { t } = useTranslation()
  const styles = useStyles({ color: colors })
  const bodyState = useGetData()
  const listBreadCrumb = useMemo(() => {
    if ([NavigatioStateType.SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE].includes(location?.state?.type)) {
      return [
        {
          id: 'schedule',
          label: 'schedule',
          navigate: () => { navigate(`/dashboard/calendar`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleList',
          navigate: () => { navigate(`/dashboard/calendar/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'scheduleDetail',
          label: 'scheduleDetail',
          navigate: () => { navigate(`/dashboard/calendar/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { }
        },
      ]
    }
    if ([NavigatioStateType.USER_SCHEDULE, NavigatioStateType.USER_RECURRENCE].includes(location?.state?.type)) {
      return [
        {
          id: 'schedule',
          label: 'schedule',
          navigate: () => { navigate(`/dashboard/schedule-user`) }
        },
        {
          id: 'scheduleList',
          label: 'scheduleDetail',
          navigate: () => { navigate(`/dashboard/schedule-user/detail/${location.state?.id}`, { state: location.state }) }
        },
        {
          id: 'reportFolioList',
          label: 'reportFolioList',
          navigate: () => { }
        },
      ]
    }
    return undefined
  }, [])
  const [headerScheduleDetail, setHeaderScheduleDetail] = useState<QuestionnaireProps>()
  const isExternal = useMemo(() => {
    const queary = new URLSearchParams(location.search)
    const id = queary.get('id')
    const paramId = id ? `&id=${queary.get('id')}` : ''
    return paramId
  }, [location.search])
  const { download, openSnackbar, downloadCSV, downloadPDF, downloadWORD, closeOpenSnakbar } = useDownload({
    docName: t('reportFolio.dashboard.header.title'),
    query: `${returnQueryWithPagination({ filter: bodyState?.filterData?.filterString, sort: bodyState?.filterData?.query?.sort })}${isExternal}`,
    downloadFuntion: reportFolioServices.downloadFolio,
  })

  //Modals States:
  const [modalOpenReassign, setModalOpenReassign] = useState(false);
  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [modalOpenCancel, setModalOpenCancel] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMasive, setSnarbarMasive] = useState({ message: '', type: Types.SUCCESS, open: false, })

  const handleOpenModal = () => {
    if (bodyState?.selectedIds.length === 0 && !bodyState.isChecked) {
      setSnackbarOpen(true)
    } else {
      setModalOpenReassign(true)
      bodyState.fetchDepartmentsWithFolios();
    }
  }

  const handleCloseModal = () => {
    setModalOpenReassign(false);
  };

  const handleOpenModalDelete = () => {
    if (bodyState?.selectedIds.length === 0 && !bodyState.isChecked) {
      setSnackbarOpen(true)
    } else {
      setModalOpenDelete(true)
    }
  }

  const handleCloseModalDelete = () => {
    setModalOpenDelete(false);
  };

  const handleOpenModalCancel = () => {
    if (bodyState?.selectedIds.length === 0 && !bodyState.isChecked) {
      setSnackbarOpen(true)
    } else {
      setModalOpenCancel(true)
    }
  }

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false)
  }

  const handleCloseModalCancel = () => {
    setModalOpenCancel(false);
  };

  const updateTable = (data: Query) => {
    //bodyState.requestAllIds()
    bodyState?.requestTable({ query: `${returnQuery(data)}${isExternal}` })
  }

  const headerFronSchedule = () => {
    const state = location.state

    if ([NavigatioStateType.SCHEDULE, NavigatioStateType.USER_SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE, NavigatioStateType.USER_RECURRENCE].includes(state?.type)) {
      setHeaderScheduleDetail({
        answerList: [{ label: state?.item ?? '' }],
        question: state?.question ?? '',
        title: state?.title ?? '',
        parentId: state?.parentId,
        version: state?.version,
      })
    }
  }

  useLayoutEffect(() => {
    headerFronSchedule()
  }, [])


  const handleSwitch = () => {
    const options: ObjectGeneric = {
      1: (
        <List
          headers={bodyState?.headers}
          name={t('reportFolio.dashboard.header.title')}
          sortModel={bodyState?.filterData?.query?.sort ? bodyState?.filterData?.query?.sort : undefined}
          loading={bodyState?.loading}
          sortTable={bodyState?.filterData?.sortTable}
          handlePagination={bodyState?.filterData?.handlePagination}
          paginationModel={bodyState?.filterData?.paginationModel}
          total={bodyState?.total}
          color={colors}
          table={{ row: bodyState?.row, column: bodyState?.columns }}
        />
      ),
    }
    return options[toggleSelection] ?? <></>
  }

  const handleMenuOptions = () => {
    let menu = bodyState?.detail?.reportUrl
      ? menuItems
      : menuItems?.filter((itemMenu) => itemMenu.value !== 2)

    if (bodyState?.localStatus && [Status.RESPONDED, Status.AWAIT_SOLUTION].includes(bodyState?.localStatus) && !location.search) {
      menu = [...reassignMenu, ...menu]
    }
    if (!bodyState?.isCreatorOrAdminOrAssing || !bodyState.flagEdit) {
      menu = menu.filter(item => ![4, 5, 7].includes(item.value))
    }
    if (!bodyState?.canReassignUser) {
      menu = menu.filter(item => ![6].includes(item.value))
    }
    return menu
  }

  useEffect(() => {
    executeFunction({
      execute: () => {
        updateTable(bodyState?.filterData?.query);
        bodyState.setSelectedIds([]);
        bodyState.setNotFolioSelected([]);
      }
    })
  }, [bodyState?.filterData?.query?.all])

  const handleCancel = async (comment: string) => {
    //const isHeaderSelected = bodyState.selectedIds.length + bodyState.notFolioSelected.length === bodyState.total.totalItems;
    const isHeaderSelected = bodyState.isChecked;
    const payload = {
      motive: comment,
      all: isHeaderSelected,
      folios_ids: isHeaderSelected ? [] : bodyState.selectedIds,
      not_folios_ids: isHeaderSelected ? bodyState.notFolioSelected : []
    };

    try {
      const response = await bodyState.HandleCancelFolios(payload, bodyState.isChecked ? returnQuery(bodyState?.filterData?.query) : undefined);
      if (response.code == '01') {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.noCancelAllFolios'),
          type: Types.ERROR,
        }))
      } else {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.CancelationSucces'),
          type: Types.SUCCESS,
        }))
      }

      bodyState.setSelectedIds([]);
      bodyState.setNotFolioSelected([]);
      //bodyState.requestAllIds();
      bodyState?.requestTable({ query: `${returnQuery(bodyState?.filterData?.query)}${isExternal}` })

    } catch (error) {
      setSnarbarMasive((prev) => ({
        ...prev,
        open: true,
        message: t('reportFolio.detail.general.errorToCancelMasive'),
        type: Types.ERROR,
      }))
    }
  };

  const handleDelete = async () => {
    //const isHeaderSelected = bodyState.selectedIds.length + bodyState.notFolioSelected.length === bodyState.total.totalItems;
    const isHeaderSelected = bodyState.isChecked;
    const payload = {
      all: isHeaderSelected,
      folios_ids: isHeaderSelected ? [] : bodyState.selectedIds,
      not_folios_ids: isHeaderSelected ? bodyState.notFolioSelected : []
    };
    try {
      await bodyState.HandleDeleteFolios(payload, bodyState.isChecked ? returnQuery(bodyState?.filterData?.query) : undefined);
      setSnarbarMasive((prev) => ({
        ...prev,
        open: true,
        message: t('reportFolio.detail.general.EliminatationSucces'),
        type: Types.SUCCESS,
      }))
      bodyState.setSelectedIds([]);
      bodyState.setNotFolioSelected([]);
      //bodyState.requestAllIds();
      bodyState?.requestTable({ query: `${returnQuery(bodyState?.filterData?.query)}${isExternal}` })
    } catch (error) {
      setSnarbarMasive((prev) => ({
        ...prev,
        open: true,
        message: t('reportFolio.detail.general.errorToDeleteMasive'),
        type: Types.ERROR,
      }))
    }
  };

  const closeSnackbar = () => { setSnarbarMasive((prev) => ({ ...prev, open: false, })) }

  const handleReassign = async (user_asign_id: number) => {
    //const isHeaderSelected = bodyState.selectedIds.length + bodyState.notFolioSelected.length === bodyState.total.totalItems;
    const isHeaderSelected = bodyState.isChecked;
    const payload = {
      user_asign_id: user_asign_id,
      all: isHeaderSelected,
      folio_ids: isHeaderSelected ? [] : bodyState.selectedIds,
      not_folio_ids: isHeaderSelected ? bodyState.notFolioSelected : []
    };

    try {
      const response = await bodyState.ReassignFolios(payload, bodyState.isChecked ? returnQuery(bodyState?.filterData?.query) : undefined);
      if (response.code == '01') {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.noReassignAllFolios'),
          type: Types.ERROR,
        }))
      } else if (response.code == '02') {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.noFoliosCouldBeReassigned'),
          type: Types.ERROR,
        }))
      } else if (response.code == 'ERR_NOT_FOUND_DATA') {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.foliosNotFound'),
          type: Types.ERROR,
        }))
      } else if (response.code == '04') {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.foliaHasProcessed'),
          type: Types.ERROR,
        }))
      } else {
        setSnarbarMasive((prev) => ({
          ...prev,
          open: true,
          message: t('reportFolio.detail.general.ReassignFolio'),
          type: Types.SUCCESS,
        }))
      }
      bodyState.setSelectedIds([]);
      bodyState.setNotFolioSelected([]);
      //bodyState.requestAllIds();
      bodyState?.requestTable({ query: `${returnQuery(bodyState?.filterData?.query)}${isExternal}` })

    } catch (error) {
      setSnarbarMasive((prev) => ({
        ...prev,
        open: true,
        message: t('reportFolio.detail.general.errorToReasignMasive'),
        type: Types.ERROR,
      }))
    }
  };

  const downloadCustome = () => {
    bodyState.getDetailInform({ query: returnQuery(bodyState?.filterData?.query) })
  }

  useEffect(() => {
    if (bodyState.uuid) {
      const interval = setInterval(() => {
        bodyState.getDetailInform({ query: returnQuery(bodyState?.filterData?.query) });
      }, 30000);
      return () => clearInterval(interval);
    }
  }, [bodyState.uuid])

  return (
    <Box key={'dashboard-reportFolio'} sx={styles.container}>
      {/* HEADER */}

      <BreadCrumb
        removeBreadcrumb={['report-folio', 'calendar', 'schedule-user']}
        replaceLabels={{
          dashboard: 'maintenanceRequest'
        }}
        breadList={[NavigatioStateType.SCHEDULE_RECURRENCE, NavigatioStateType.USER_RECURRENCE].includes(location.state?.type) ? [] : listBreadCrumb}
      />

      <Box sx={styles.headerSchedule}>
        {
          !!headerScheduleDetail && (
            <HeaderQuestionnaire {...headerScheduleDetail} />
          )
        }
      </Box>

      <Box sx={styles.header}>
        <Typography variant='title_grey_big'>{t('reportFolio.newDashboard.header.title')}</Typography>

        <Box sx={styles.flex}>
          <LinearProgressDownload show={bodyState.isLoading} text={t('reportFolio.setting.generateFolioInform')} />
          <ModelDownloadButtons
            isFolio csv={downloadCSV}
            pdf={downloadPDF}
            word={downloadWORD}
            disableCSV={download?.excel}
            disablePDF={download?.pdf}
            disableWORD={download?.word}
            extraDownload={
              [
                {
                  disable: bodyState.isLoading,
                  dowload: () => { downloadCustome() },
                  label: 'reportFolio.newDashboard.btnsHeader.resumenFolios',
                  type: 'pdf'
                }
              ]
            }
            customeLabels={{
              csv: t('reportFolio.newDashboard.btnsHeader.inExcel'),
              pdf: t('reportFolio.newDashboard.btnsHeader.inPdf'),
              word: t('reportFolio.newDashboard.btnsHeader.inWord')
            }}
            styleType={true}
          />

          <MainButtons
            onCancelClick={handleOpenModalCancel}
            onDeleteClick={handleOpenModalDelete}
            onReassignClick={handleOpenModal}
            cleanFilter={bodyState.filterData.cleanFilter}
            counter={bodyState.filterData.counter}
          />

        </Box>
      </Box>


      {/* MAIN COMPONENTS */}
      {handleSwitch()}


      <BaseMenu
        sx={[styles.baseMenu, bodyState?.detail.positionMenu]}
        anchorEl={bodyState?.anchorEl}
        setAnchorEl={bodyState?.setAnchorEl}
        menuItems={handleMenuOptions()}
        click={(item) => {
          bodyState?.optionMenu({ item: item as Item })
        }}
      />
      {/* Float Components */}
      <BaseModal sx={styles.modal as SxProps} open={bodyState?.resendReport?.open}>
        <Box style={styles.resendReportContainer as any}>
          <IconButton
            sx={styles.close}
            onClick={() => {
              bodyState?.closeResendModal()
            }}
          >
            {icons('simple-close')}
          </IconButton>

          <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.title')}</Typography>

          <DinamicForm input={Object.values(resendReportForm)} values={bodyState?.resendReport} onChange={bodyState?.handleSendReportData} spacing={{ row: 0 }} />

          <Typography sx={styles.titleSend}>{t('reportFolio.modal.sendReport.emails')}</Typography>

          <DinamicForm input={Object.values(resendReportFormEmails)} values={bodyState?.resendReport} onChange={bodyState?.handleSendReportData} />

          <Box sx={styles.resendButton}>
            <LoadingButton
              loading={!!bodyState?.disabled.resendButtonLoading}
              disabled={!!bodyState?.disabled?.resendButton}
              type="submit"
              onClick={() => {
                bodyState?.submitResendReport()
              }}
              sx={styles.button}
              variant="contained"
            >
              {t('reportFolio.buttons.resend')}
            </LoadingButton>
          </Box>
        </Box>
      </BaseModal>

      <ConfirmModal
        open={bodyState.confirmModal.open}
        onClose={bodyState.confirmModal.onClose}
        onConfirm={bodyState.confirmModal.onConfirm}
        title={bodyState.confirmModal.title}
        description={bodyState.confirmModal.description}
      />

      {
        !location.search && (
          <FiltersDrawer cleanFilter={bodyState?.filterData?.cleanFilter} count={bodyState?.filterData?.counter} right={0} top={50}>
            <Box sx={styles.section}>
              <DinamicForm
                errors={bodyState?.filterData?.errors}
                input={Object.values(bodyState?.inputFilter)}
                values={bodyState?.filterData?.filterData}
                onChange={bodyState?.filterData?.onChange}
                filter={true}
              />
            </Box>
          </FiltersDrawer>
        )
      }

      <SnackSimple close={closeOpenSnakbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />

      <SnackSimple close={bodyState?.closeSnackbar} open={bodyState?.snackbar.open} type={bodyState?.snackbar.type} message={bodyState?.snackbar.message} />

      <SnackSimple
        open={snackbarOpen}
        close={handleCloseSnackbar}
        message={t('reportFolio.detail.general.selectAtLeastOneFolio')}
        type={Types.ERROR}
      />

      <SnackSimple
        open={snackbarMasive.open}
        close={closeSnackbar}
        message={snackbarMasive.message}
        type={snackbarMasive.type}
      />

      <ReassingModal
        open={modalOpenReassign}
        onClose={handleCloseModal}
        onReassign={handleReassign}
        countFolios={bodyState.isChecked ? (bodyState.total.totalItems - bodyState.notFolioSelected.length).toString() : bodyState?.selectedIds.length.toString() ?? 0}
        items={bodyState?.departmentsWithFolios}
      />

      <CancelModal
        open={modalOpenCancel}
        onClose={handleCloseModalCancel}
        onDelete={handleCancel}
        countFolios={bodyState.isChecked ? (bodyState.total.totalItems - bodyState.notFolioSelected.length).toString() : bodyState?.selectedIds.length.toString() ?? 0}
      />

      <ConfirmModal
        open={modalOpenDelete}
        onClose={handleCloseModalDelete}
        onConfirm={handleDelete}
        title={`Confirmación`}
        description={t('reportFolio.detail.general.CancelFolios', { count: bodyState.isChecked ? (bodyState.total.totalItems - bodyState.notFolioSelected.length) : Number(bodyState?.selectedIds.length) })}
      />

    </Box>
  )
}
